import { css } from 'styled-components';
export function labelBaseStyle(props) {
    const { $accent, $muted, theme } = props;
    const { fonts } = theme.sanity;
    return css `
    text-transform: uppercase;

    &:before {
      content: '';
      display: block;
      height: 0;
    }

    &:after {
      content: '';
      display: block;
      height: 0;
    }

    ${$accent &&
        css `
      color: var(--card-accent-fg-color);
    `}

    ${$muted &&
        css `
      color: var(--card-muted-fg-color);
    `}

    & code {
      font-family: ${fonts.code.family};
      border-radius: 1px;
    }

    & a {
      text-decoration: none;
      border-radius: 1px;
    }

    & [data-sanity-icon] {
      vertical-align: baseline;
    }
  `;
}
//# sourceMappingURL=styles.js.map